import * as types from "./types";
import createReducer from "../../utils/createReducer";

import initialState from './initialState';

let reducersMap = {
   [types.SET_IS_OPEN_AGE_VERIFICATION_PROCESS_MODAL]: (state, action) => {

      return {
         ...state,
         isOpenAgeVerificationProcessModal: action.payload,
      }
   },
   [types.SET_IS_OPEN_AGE_VERIFIED_MODAL]: (state, action) => {
      return {
         ...state,
         isOpenAgeVerifiedModal: action.payload,
      }
   },
}

export default createReducer(initialState)(reducersMap);
